import React from "react"
import styled from "styled-components"
import {Link} from "@reach/router"
import {Box, Container, Drawer, List, ListItem, ListItemIcon, ListItemText} from "@material-ui/core"
import AppBar from "@material-ui/core/AppBar"
import IconButton from "@material-ui/core/IconButton"
import MenuIcon from "@material-ui/icons/Menu"
import DescriptionIcon from "@material-ui/icons/Description"
import Toolbar from "@material-ui/core/Toolbar"

function Layout({children}) {
	const [state, setState] = React.useState({
		showNav: false,
	})

	const toggleNav = (val) => () => {
		setState({...state, showNav: val})
	}

	const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone

	return (
		<>
			<AppBar position="static">
				<Toolbar variant="dense">
					<IconButton edge="start" color="inherit" aria-label="menu" onClick={toggleNav(true)}>
						<MenuIcon />
					</IconButton>
					<Box flexGrow={1}>InDebted Analytics</Box>
					<small>Local timezone: {timezone}</small>
				</Toolbar>
			</AppBar>
			<Drawer open={state.showNav} onClose={toggleNav(false)}>
				<NavList>
					<NavItem
						navPath="/client-files"
						displayLabel="Client Files"
						iconElement={<DescriptionIcon />}
						closeNav={toggleNav(false)}
					/>
				</NavList>
			</Drawer>
			<Container maxWidth={false}>{children}</Container>
		</>
	)
}

function NavItem({navPath, displayLabel, iconElement, closeNav}) {
	return (
		<ListItem button onClick={closeNav} component={Link} to={navPath}>
			<ListItemIcon>{iconElement}</ListItemIcon>
			<ListItemText primary={displayLabel} />
		</ListItem>
	)
}

const NavList = styled(List)`
	width: 250px;
`

export {Layout}
